//
// RangeEntryAttributes.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../../lib";
import "../../GTLModel";
import "../../ColorModel";
import "../MarkerAttributes";

var RangeEntryAttributes = createModule("gtl::RangeEntryAttributes", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        markerAttributes: 1,
        rangeColorModel: 1,
        rangeAltColorModel: 1,
        rangeColor: 10,
        kpiColor: 10,
        rangeAltColor: 10,
        label: 7,
        kpiActiveColor: 10,
    },
    ,
    ,
    {
        setStyle: [0,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default RangeEntryAttributes;
